var _path, _path2, _rect, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8999 4.8005C6.8999 4.19299 7.39239 3.7005 7.9999 3.7005H18.9928L25.0999 9.80761V27.2005C25.0999 27.808 24.6074 28.3005 23.9999 28.3005H7.9999C7.39239 28.3005 6.8999 27.808 6.8999 27.2005V4.8005Z",
    fill: "#F4FBFF",
    stroke: "#75C7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 3.20001L25.6002 9.60001H20.8002C19.9165 9.60001 19.2002 8.88367 19.2002 8.00001V3.20001Z",
    fill: "#75C7FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13.3333,
    width: 20.6667,
    height: 11.3333,
    rx: 2,
    fill: "#2C3747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9878 22V16.1818H19.7719V17.0653H17.0418V18.6449H19.5759V19.5284H17.0418V21.1165H19.7946V22H15.9878Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4565 22V16.1818H12.5105V21.1165H15.073V22H11.4565Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3152 16.1818V22H9.26123V16.1818H10.3152Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57373 22V16.1818H8.301V17.0653H5.62771V18.6449H8.04532V19.5284H5.62771V22H4.57373Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.dcdb5add62960063f75f6a452c9f8dd9.svg";
export { ForwardRef as ReactComponent };